import { useEffect } from "react";

import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { GridAlgorithm } from "@googlemaps/markerclusterer";

//Components
import stellplatz from "../../assets/images/marker_Stellplatz.png";
import stellplatzVE from "../../assets/images/marker_Stellplatz_VE.png";
import entsorgungsstation from "../../assets/images/marker_Entsorgungsstation.png";
import markerpng from "../../assets/images/Marker_Google.png";
import premiumplatzVEpng from "../../assets/images/marker-pro-ve.png";
import premiumplatzpng from "../../assets/images/marker-pro.png";
import marker_cluster from "../../assets/images/marker_cluster.png";

const ClusterMarker = (data) => {
  var markers = [];

  if (typeof window.markers !== "undefined" && window.markers !== null) {
    window.markers.forEach((marker) => {
      marker.setMap(null);
    });
    window.markers = null;
  }
  if (typeof window.Clusterer !== "undefined" && window.Clusterer !== null) {
    window.Clusterer.setMap(null);
  }

  data.items.forEach((item) => {
    var marker = new window.google.maps.Marker({
      position: {
        lat: parseFloat(item.gps.latitude),
        lng: parseFloat(item.gps.longitude),
      },
      href: `/map/pitch/${item.id}`,
      icon: {
        url:
          item.premium === "1" && item.marker === "Stellplatz "
            ? premiumplatzpng
            : item.premium === "1" &&
              item.stellplatztyp === "Stellplatz mit Entsorgungsstation"
            ? premiumplatzVEpng
            : item.premium !== "1" && item.stellplatztyp === "Stellplatz"
            ? stellplatz
            : item.premium !== "1" &&
              item.stellplatztyp === "Stellplatz mit Entsorgungsstation"
            ? stellplatzVE
            : item.premium !== "1" &&
              item.stellplatztyp === "Entsorgungsstation"
            ? entsorgungsstation
            : markerpng,
      },
      title: item.id.toString(),
    });

    marker.addListener("click", () => {
      if (window.location.href.indexOf("typ=Entsorgungsstation") !== -1) {
        window.open(marker.href, "_blank");
        /*                    document.getElementById("setShowModalDetail").click();
                                    setTimeout(function (){
                                        document.getElementById("showModalDetailContent").innerHTML = '<iframe style="width: 100%; height: 100%" frameborder="0" src="'+marker.href+'"></iframe>';
                                    },1000);*/
      } else {
        window.location.href = marker.href;
      }
    });

    /*            const infowindow = new window.google.maps.InfoWindow({
                        content: item.id,
                        ariaLabel: "Uluru",
                    });

                    marker.addListener("click", () => {
                        infowindow.open({
                            anchor: marker,
                            map,
                        });
                    });*/

    if (markers.indexOf(marker) === -1) {
      markers.push(marker);
    } else {
    }
  });
  var map = window.gmap;
  window.markers = markers;

  const renderer = {
    render: ({ count, position }) =>
      new window.google.maps.Marker({
        label: { text: String(count), color: "white", fontSize: "10px" },
        position,
        icon: { url: marker_cluster },
        // adjust zIndex to be above other markers
        zIndex: Number(window.google.maps.Marker.MAX_ZINDEX) + count,
      }),
  };

  const mymarkerClusterer = new MarkerClusterer({
    markers,
    map,
    algorithm: new GridAlgorithm({
      maxDistance: 150,
      minZoom: 0,
      maxZoom: 11,
      log: false,
    }),
    renderer,
  });
  window.Clusterer = mymarkerClusterer;

  useEffect(() => {}, [markers]);

  return null;
};

export default ClusterMarker;
